<div class="margin">


  <div class="container update" *ngIf="show">
  <mat-card>
    <mat-card-title>Update Your Profile</mat-card-title>
    <mat-card-subtitle>Please Enter Your Credentials</mat-card-subtitle>

    <mat-card-content>
      <form [formGroup]="signupForm" (ngSubmit)="onsubmit()">
      <div class="row">
        <div class=col-md-6>
          <mat-form-field class="example-full-width">
            <mat-label>Name</mat-label>
            <input type="text" matInput formControlName="name">
            <mat-error *ngIf="signupForm.get('name').errors">
              Name is <strong>required</strong>
            </mat-error>
          </mat-form-field><br/>
          <mat-form-field>
            <mat-label>Age</mat-label>
            <input type="number" matInput formControlName="age">
            <mat-hint>Should be in between 15 to 100</mat-hint>
            <mat-error *ngIf="signupForm.get('age').errors">
              Please fill correct <strong>Age</strong>
            </mat-error>
          </mat-form-field><br/>
          <mat-form-field>
            <mat-label>Gender</mat-label>
            <mat-select formControlName="gen">
              <mat-option *ngFor="let g of gender" [value]="g">
                {{g}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="signupForm.get('gen').errors">
              Gender is <strong>required</strong>
            </mat-error>
          </mat-form-field><br/>
        </div>
        <div class=col-md-6>

          <mat-form-field>
            <mat-label>Email</mat-label>
            <input matInput formControlName="email">
            <mat-hint>Fill your updated email</mat-hint>
            <mat-error *ngIf="signupForm.get('email').errors">
              Email should be <strong>correct</strong>
            </mat-error>
          </mat-form-field><br/>
          <mat-form-field>
            <mat-label>Password</mat-label>
            <input type="password" matInput formControlName="password">
            <mat-hint>Password Should be upto 8 charecters</mat-hint>
            <mat-error *ngIf="signupForm.get('name').errors">
              Password should be of <strong>8 charecters</strong>
            </mat-error>
          </mat-form-field><br/>
        </div>
      </div>
      <hr>
      <button type="submit" mat-stroked-button [disabled]="!signupForm.valid" class="m-2">Submit</button>
      <button type="reset" mat-stroked-button>Reset</button><br/>
    </form>

    </mat-card-content>

  </mat-card>
  </div>


<div class="container val">
  <mat-card>
    <mat-card-header>
      <mat-card-title>
        <h1 class="he">Go Forward to predict your disease</h1>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <hr>
      <div class="row">
        <div class="col-md-5">
          <ul>
            <li>This is Machine learning based predictive model technique based on random forest classifier algorithm.</li>
            <li>There is No perfect Machine learning model which gives 100 percent accuracy</li>
            <li>This model is trained on 303 dataset for heart disease</li>
            <li><h2>This model gives <u>86%</u> accuracy.</h2></li>
          </ul>
        </div>
        <div class="col-md-5">
          <ul>
            <li>You just need to fill the following form enteries on the next page.</li>
            <li>This description for every form field is given on the side tips.</li>
            <li><h2>Model is correct upto 8.5 predictions for every 10 predictions.</h2></li>
          </ul>
        </div>
      </div>
    </mat-card-content>
    <mat-card-footer>
      <hr>
      <a routerLink="/user/form" class="btn btn-primary m-2">Predict Your Disease</a>
      <button type="button" class="btn btn-secondary m-2" (click)="toggle()">{{buttonName}}</button>
    </mat-card-footer>
  </mat-card>
</div>

</div>
